import { devtools } from 'zustand/middleware';

import { create } from '@app/store/zustand/helpers/create';

interface InteractionsState {
    cartOpen: boolean;
}
interface InteractionsStateStore extends InteractionsState {
    toggleCartOpen: (state?: boolean) => void;
}

const initialState: InteractionsState = {
    cartOpen: false,
};

export const useInteractionsStore = create<InteractionsStateStore>()(
    devtools((set) => ({
        ...initialState,
        toggleCartOpen: (val) => set((state) => ({ cartOpen: val !== undefined ? val : !state.cartOpen })),
    })),
);
